export default {
    resalesLanding: {
        sentOn: "Gesendet am",
        toggleContact: "Agenturkontakt ein-/ausblenden",
        propertyOffers: "Immobilienangebote",
        openGallery: "Fotogalerie öffnen",
        prevPhoto: "Vorheriges Foto",
        nextPhoto: "Nächstes Foto",
        close: "Schließen",
        photo: "Foto",
        description: "Beschreibung",
        more: "Mehr",
        less: "Weniger",
        intFloorSpace: "Nutzfläche",
        build: "Bebaut",
        terrace: "Terrasse",
        garden: "Garten",
        buildYear: "Baujahr",
        fees: "Gebühren",
        communityFees: "Gemeinschaftsgebühren",
        basuraTax: "Müllgebühr (Basura)",
        ibiFees: "IBI (Grundsteuer)",
        securityDeposit: "Kaution",
        perMonth: "/Monat",
        perWeek: "/Woche",
        disclaimer: "Haftungsausschluss",
        energyCertificate: "Energieausweis",
        pending: "Ausstehend",
        rating: "Bewertung",
        presentedBy: "Präsentiert von",
        propertyDetails: "Immobiliendetails",
        reference: "Referenz",
        referenceShort: "Ref",
        unitUnavailable: "Nicht mehr verfügbar",
        availableUnits: "Verfügbare Einheiten und Preise",
        availableUnitsShort: "Verfügbare Einheiten",
        unit: "Einheit",
        type: "Typ",
        floors: "Etagen",
        bedrooms: "Schlafz.",
        bathrooms: "Bäder",
        surfaceArea: "Innenfläche",
        price: "Preis",
        status: "Status",
        unitAvailable: "Verfügbar",
        unitReserved: "Reserviert",
        unitSold: "Verkauft",
        seeMore: "Mehr anzeigen",
        seeLess: "Weniger anzeigen",
        floor: "Etage",
        storeys: "Stockwerke",
        keyReady: "Bezugsfertig",
        touristLicence: "Touristenlizenz",
        firstOccupationLicence: "Erstbezugsgenehmigung",
        notKnown: "Nicht bekannt",
        notProvided: "Nicht angegeben",
        yes: "Ja",
        no: "Nein",
        mortgageAvailable: "Finanzierung möglich",
        guaranteedRental: "Garantierte Mieteinnahmen",
        sellBeforeCompletion: "Abtretung des Vertrags vor Fertigstellung",
        sellBeforeCompletionYes: "Zulässig",
        sellBeforeCompletionNo: "Nicht zulässig",
        sellBeforeCompletionNotProvided: "Nicht angegeben",
        reservation: "Reservierung",
        contract: "Vertrag",
        construction: "Bau",
        completion: "Fertigstellung",
        co2: "CO2",
        energyConsumption: "Energieverbrauch",
        co2PerYear: "kg CO2/Jahr",
        kwhPerYear: "kWh/Jahr",
        features: "Ausstattung",
        viewDetails: "Details anzeigen",
        hideDetails: "Immobiliendetails ausblenden",
        backToResults: "Ergebnisse",
        viewProperty: "Immobilie ansehen",
        prevProperty: "Zurück",
        nextProperty: "Weiter",
        viewAllFeatures: "Alle Ausstattungsmerkmale anzeigen",
        allFeatures: "Alle Ausstattungsmerkmale",
        infoOnRequest: "Informationen auf Anfrage",
        tbc: "n.z.b.",
        featureCategoryLabels: { pool: "Pool", views: "Aussicht", parking: "Parkplatz", kitchen: "Küche", condition: "Zustand", garden: "Garten" },
        featureQualifierFormat: "{value} {category}",
        location: "Lage",
        agencyInformation: "Informationen zur Agentur",
        buyingCosts: "Kaufnebenkosten",
        propertyPrice: "Immobilienpreis:",
        priceNote: "**Der Preis versteht sich zzgl. Steuern und Kaufnebenkosten.",
        estimatedPurchaseCosts: "Geschätzte Kaufnebenkosten:",
        hide: "Ausblenden",
        showBreakdown: "Aufschlüsselung der Kaufnebenkosten anzeigen",
        purchaseCostBreakdown: "Aufschlüsselung der Kaufnebenkosten",
        concept: "Position",
        application: "Anwendung",
        rowTransferTax: "ITP (Grunderwerbsteuer, Bestandsimmobilie)",
        rowVat: "MwSt. (Neubau)",
        rowVatLand: "MwSt.",
        vatApplication: "10 % (4 % bei gefördertem Wohnraum)",
        rowStampDuty: "Stempelsteuer (AJD)",
        rowNotary: "Notar",
        rowLandRegistry: "Grundbuchamt",
        officialTariff: "Amtlicher Tarif",
        costRangeNotePrefix: "*Die gesamten Käuferkosten liegen üblicherweise zwischen",
        and: "und",
        ofPurchasePrice: "des Kaufpreises.",
        costApproxNote: "*Die geschätzten Kaufkosten dienen nur zur Orientierung. Die tatsächlichen Kosten können je nach Immobilie und den Umständen des Käufers variieren. Wir empfehlen, für eine genaue Berechnung professionelle Beratung einzuholen.",
        additionalInformation: "Zusätzliche Informationen",
        addInfoDocument: "*Verkürztes Informationsdokument gemäß dem andalusischen Dekret 218/2005 verfügbar",
        addInfoNoFees: "*Der Käufer zahlt keine Maklergebühren",
        formHeading: "Möchten Sie mehr über die Preise und die Immobilie erfahren?",
        firstName: "Vorname",
        enterNumber: "Nummer eingeben",
        email: "E-Mail",
        searchCountry: "Land oder Vorwahl suchen",
        noMatches: "Keine Treffer",
        consent: "Mit dem Klick auf die Schaltfläche willigen Sie in die Verarbeitung Ihrer personenbezogenen Daten gemäß der Datenschutzerklärung ein, einschließlich der Erhebung, Speicherung und Nutzung der angegebenen Informationen, um Sie zu kontaktieren und Ihnen die erforderlichen Informationen bereitzustellen.",
        send: "Senden",
        contactUs: "Kontaktieren Sie uns",
        yourMessage: "Ihre Nachricht",
        agreeData: "Ich bin damit einverstanden, meine Daten anzugeben, um eine Antwort auf meine Informationsanfrage zu erhalten.",
        agreeContact: "Ich bitte um Information und willige ein, von dem für die Vermarktung verantwortlichen Unternehmen bzw. dem zuständigen Vermarkter über meine freiwillig zu diesem Zweck angegebenen Kontaktdaten kontaktiert zu werden.",
        reject: "Ablehnen",
        like: "Gefällt mir",
        liked: "Gemerkt",
        rejected: "Abgelehnt",
        offerRejected: "Angebot abgelehnt",
        contact: "Kontakt",
        call: "Anrufen",
        calling: "Anruf an",
        noPhone: "Keine Telefonnummer verfügbar",
        enquirySent: "Anfrage gesendet — wir kontaktieren",
        yourDetails: "Ihre Daten",
        respondedTo: "beantwortet",
        noProperties: "Keine Immobilien vorhanden.",
        soldOutBody: "Die Immobilien dieses Angebots wurden verkauft oder sind nicht mehr auf dem Markt. Bitte wenden Sie sich für eine aktualisierte Auswahl an die Agentur.",
        expiredTitle: "Dieser Angebotslink ist abgelaufen",
        expiredBody: "Bitte wenden Sie sich an die Agentur, um einen aktuellen Link für diese Immobilien zu erhalten.",
        unavailableTitle: "Angebot nicht verfügbar",
        unavailableBody: "Dieses Angebot konnte nicht geladen werden. Der Link ist möglicherweise ungültig oder der Dienst vorübergehend nicht erreichbar — bitte versuchen Sie es später erneut oder wenden Sie sich an die Agentur.",
    },
    title: "Eigenschaften von {agencyName}",
    in: "im",
    propertiesFound: "eigenschaften gefunden",
    toDay: "Heute",
    days: "tage",
    week: "Woche",
    year: "Jahr",
    month: "Monat",
    prev: "Zurück",
    next: "Nächster",
    backToList: "Zurück zur Liste",
    sorry: "Entschuldigung, wir",
    cantFind: "kann nicht finden",
    lookingFor: "die Seite, die Sie suchen ...",
    thankYou: "Vielen Dank für Ihren Besuch auf unserer Website",
    pleaseContact: "Bitte kontaktieren Sie den Agenten für eine neue URL.",
    ForSale: "VERKAUF",
    ShortTermRental: "Kurze Miete",
    LongTermRental: "Lange Miete",
    showMore: "Zeig mehr",
    showLess: "Zeige weniger",
    price: "Preis",
    pricePer: "Preis pro",
    built: "Bauen",
    floorSpace: "Innere Bodenfläche",
    terrace: "Terrasse",
    garden: "Garten",
    plot: "Handlung",
    propTitle: '{subType} {searchType} im {location}',
    propTitleShort: '{subType} im {location}',
    notAvailable: "Nicht verfügbar",
    notFound: 'Seite nicht gefunden',
    emptyProperties: "Es wurden keine Immobilien gefunden. Bitte wenden Sie sich an Ihren Agenten, um weitere Informationen zu erhalten.",
    linkExpired: "Oops, dieser Link ist abgelaufen. Wenden Sie sich an Ihren Immobilienmakler, um einen aktualisierten Immobilienlink zu erhalten.",
    newDevelopment: "Neuentwicklung",
    agencyRaiiNo: "Registrierungsnummer der Agentur",
    home: {
        verifyYourURLHere: "Überprüfen Sie hier Ihre URL. Melden Sie sich dazu in Ihrem Webbrowser bei WhatsApp an und kopieren Sie die URL von WhatsApp hierher.",
        pasteUrlHere: "URL hier einfügen",
        verifyUrl: "Überprüfen Sie die URL",
        whatIsPropertyViewer: "Was ist Property-Viewer.com?",
        thisIsWebsiteIsUsed: "Diese Website wird von Immobilienmaklern verwendet, um Immobilien an ihre Kunden zu senden. Es ist ein Produkt von {resalesonlinecom}. Im Zweifelsfall wenden Sie sich bitte an den Makler, der Ihnen Ihre Immobilienliste gesendet hat.",
        howDoesItWork: "Wie funktioniert es?",
        inThePast: "In der Vergangenheit haben Agenten PDF-Dokumente an ihre Kunden gesendet. Diese sind jedoch auf vielen Geräten nicht einfach zu sehen. Daher haben wir {propertyviewercom} erstellt, damit der Client die an sie gesendeten Eigenschaften leichter anzeigen kann.",
        createAShortList: "Der Agent erstellt eine kurze Liste von Eigenschaften. Wenn sie diese Eigenschaften mit Ihnen teilen, erhalten Sie einen Link. Wenn Sie auf diesen Link klicken, werden die Eigenschaften angezeigt."
    },

    list: {
        propertyTitle: "Klicken Sie hier, um Informationen für diese Eigenschaft anzuzeigen"
    },

    searchType: {
        ForSale: "zu verkaufen",
        ShortTermRental: "für kurzfristige Miete",
        LongTermRental: "für langfristige Miete",
    },

    rsStatus: {
        Available: "Verfügbar",
        Listing: "Auflistung",
        UnderOffer: "Unter Angebot",
        SaleAgreed: "Verkauf vereinbart",
        OffMarket: "Außerhalb des Marktes",
        Sold: "Verkauft",
        Rented: "Gemietet"
    },

    details: {
        average: "Durchschnittlich",
        averagePricesFor: "Durchschnittspreise für",
        showFullER: "Voll anzeigen",
        thisProperty: "Dieses Anwesen",
        infoNotAvailable: "Diese Informationen sind nicht verfügbar.",
        feesEnergyRating: "Gebühren, Energieeffizienzklasse",
        fees: "Gebühren",
        ibiFees: "IBI-Gebühren",
        basuraTax: "Basura Steuer",
        communityFees: "Gemeinschaftsgebühren",
        associatedCosts: "Verbundene Kosten",
        energyRating: "Energieeffizienzklasse",
        securityDeposit: "Kaution",
        energyCertificate: "Energiezertifikat",
        energyCertificatePending: "Das Energiezertifikat steht noch aus",
        energyConsumption: "Energieverbrauch",
        co2: "CO₂",
        co2PerYear: "kgCO₂/m² pro Jahr",
        kwhPerYear: "kWh/m² pro Jahr",
        other: "Andere",
        buildYear: "Baujahr",
        forSale: "Zu verkaufen",
        sold: "Verkauft",
        longTerm: "Langfristig",
        shortTermHigh: "Kurzfristig hoch",
        shortTermLow: "Kurzfristig niedrig",
        allFeatures: "Alle Features",
        aproxLocation: "Ca. Ort",
        listingAgent: "Listing agent",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        rentalLicenseRef: "Touristische Registrierungsnummer",
        agencyInformation: "Informationen zur Agentur",
    },
};